"use strict";
import {http} from '../../core';
import Config from "../../app.config";
const RequestService = http.create();
const BASE_API = Config.BASE_API;

export default {
    //新增个人投诉
    addComplaints(params){
        return RequestService.post('complaint/add',params)
    },
    //个人投诉列表
    myComplaintsList(params){
        return RequestService.get('complaint/list/my',params)
    },
    //投诉详情查看
    getComplaintsDetail(params){
        return RequestService.get('complaint/detail',params)
    },
    //管理员查看全部投诉列表
    allComplaintsList(params){
        return RequestService.get('complaint/list/super',params)
    },
    //管理员编辑投诉信息
    updateComplaints(params){
      return RequestService.post('complaint/edit',params)
    },

}


